import { render, staticRenderFns } from "./UserProfileUpdateChangePassword.vue?vue&type=template&id=33dfa495"
import script from "./UserProfileUpdateChangePassword.vue?vue&type=script&lang=js"
export * from "./UserProfileUpdateChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports